/**
 * @classdesc Auxilia nas interações com arquivos.
 */
export default class ArquivoUtil {
    constructor() {
        throw new Error('Deve existir apenas uma instância.');
    }

    static mbParaBytes(quantidadeEmMb) {
        return quantidadeEmMb * 1_000_000;
    }
}
